<template>
    <div id="option-input-container" class="col-12 mb-10"
    >
        <div class="row">
            <div class="col-10">
                <FormElementWithoutLabel>
                    <input :id="compositeId"
                           :ref="`short-input-${compositeId}`"
                           type="text"
                           class="form-control"
                           v-model="option.body"
                           @keyup.enter="addMoreAction"
                    >
                </FormElementWithoutLabel>
            </div>
            <div class="col-2">
                <button class="btn btn-lg bg-transparent"
                        @click="hasEditPermission ? confirmQuestionOptionRemoval() : unableToAddOrDeleteMsg()"
                >
                    <i class="fa-solid fa-xmark"></i>
                </button>
            </div>
        </div>

    </div>

</template>
<script setup>
import FormElementWithoutLabel from "../../../components/FormElementWithoutLabel.vue";
</script>
<script>
export default {
    props: {
        index: {
            type: Number,
            required: true
        },
        sectionIndex: {
            type: Number,
            required: true
        },
        questionIndex: {
            type: Number,
            required: true
        },
        placeholder: {
            type: String,
            required: false
        },
        option: {
            type: Object,
            required: true,
        },
        error: {
            type: Object,
            required: false,
        },
        removeOption: {
            type: Function,
            required: true,
        },
        addMoreAction: {
            type: Function,
            required: true,
        },
        hasEditPermission: {
            type: Boolean,
            required: true,
        },
        unableToAddOrDeleteMsg: {
            type: Function,
            required: true
        },
        shouldFocus: {
            type: Boolean,
            required: false,
            default: false,
        }
    },
    computed: {
        compositeId: function () {
            return `${this.sectionIndex}_${this.questionIndex}_${this.index}`;
        }
    },
    methods: {
        confirmQuestionOptionRemoval() {
            this.removeOption(this.index);
        },
    },
    mounted() {
        if (this.shouldFocus) {
            this.$nextTick(() => {
                this.$refs[`short-input-${this.compositeId}`].focus()
            })
        }
    },
}
</script>
<style scoped>
.bottom-border {
    border: 0;
    background-color: #f7fafc;
    box-shadow: none;
    border-bottom: 1px solid black;
}
</style>